import React, { useState } from 'react';
import styles from './index.module.sass';

import FindKeySkillMoves from './Find';
import { Spin } from 'antd';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { parentRedirect, haveNoLoginRedirect } from '../../hoc/redirectComp';
import useFindKeySkills from '../../hooks/useFindKeySkills';
import { ButtonList } from '../DashboardChild/Teams/ButtonList/ButtonList';
import HiddenKeySkillMoves from './Hidden';

const KeySkillMoves = () => {
  const { isFetching } = useFindKeySkills();

  const ButtonKeySkillMoves = {
    'KEY SKILL MOVES': ['/img/teams/search.png', '/img/teams/search-active.png'],
    HIDDEN: ['/img/teams/list.png', '/img/teams/list_grey.png'],
  };

  const keySkillsScreen = Object.keys(ButtonKeySkillMoves)[0];
  const hiddenScreen = Object.keys(ButtonKeySkillMoves)[1];

  const [chosenScreen, setChosenScreen] = useState(keySkillsScreen);
  return (
    <div className={styles.container}>
      <section className={styles.main_screen}>
        <header className={styles.main_screen__header}>
          <h2
            className={styles.main_screen__title}
            style={{
              textTransform: 'capitalize',
            }}
          >
            Key Skill Moves
          </h2>
          <p className={styles.main_screen__promo}>Pin this key skill to your session.</p>
          <ul className={styles.buttons}>
            <ButtonList chosenScreen={chosenScreen} changeChosenScreen={setChosenScreen}>
              {ButtonKeySkillMoves}
            </ButtonList>
          </ul>
        </header>
        <div
          style={{
            borderBottom: 'solid thin',
            width: '100%',
            borderBottomColor: 'lightgrey',
            marginBottom: '10px',
          }}
        />
        <div style={{ width: '100%', gap: '20px', display: 'flex', flexDirection: 'column' }}>
          <Spin spinning={isFetching} style={{ width: '100%' }}>
            {chosenScreen === keySkillsScreen && <FindKeySkillMoves />}
            {chosenScreen === hiddenScreen && <HiddenKeySkillMoves />}
          </Spin>
        </div>
      </section>
    </div>
  );
};

export default compose(withRouter, parentRedirect, haveNoLoginRedirect)(KeySkillMoves);
